<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    콘텐츠상세
                </div>
                <div class="list-content">
                    <item-write-component :itemType="'update'" :itemKey="itemKey"></item-write-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>
    import ItemWriteComponent from "@/components/item/ItemWriteComponent";
    export default {
        name: 'ItemUpdate',
        mixins: [],
        components: {
            ItemWriteComponent
        },
        provide() {
            return {}
        },
        props: {},
        data() {
            return {
                itemKey: Number(this.$route.params.idx),
            }
        },
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {
        },
        methods: {

        },
        watch: {},
    }
</script>
